import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import CountryService from 'services/CountryService'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import DestinationsService from '../../../../services/DestinationsService'
import {isArrayNotEmpty, isObjectEmpty, scrollToHtmlElementById, sortObjectList, isCompletedHotelInfoHistory} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './Businesses.scss'
import { Route } from 'react-router-dom/cjs/react-router-dom.min'

class Businesses extends Component {

    constructor(props) {
        super(props)
        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const countryCode = hotelInfo?.address?.country
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)

        if (!hotelCode || !hotelInfo || !countryCode) {
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        }

        const hotelBrandCode = hotelInfo.brandCode;
        let availableHotelContent = FormConst.HOTEL_CONTENT_DEFAULT_SECTIONS[hotelBrandCode];
        let proceedDirection = RouteConst.ROUTE_AIRPORTS_PAGE;
        let proceedTitle = 'Airports';
        if (availableHotelContent !== undefined && availableHotelContent.includes('S')) {
            proceedDirection = RouteConst.ROUTE_SPA_PAGE;
            proceedTitle = 'On-Site Spa';
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            countryCode: countryCode,
            continueFlow: this.props.history.location?.state?.continueFlow,
            distanceUnits: getSessionItem(SessionConst.DISTANCE_UNIT_LABEL),
            businesses: [],
            spa: {},
            otherDestinationEntries: {},
            isEdit: false,
            editIndex: -1,
            showNewBusinessFields: false,
            deleteIndex: -1,
            showDeleteModal: false,
            initialValues: { ...this.initialValues },
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            hotelInfoCompletedHistory: hotelInfoCompletedHistory,
            proceedDirection: proceedDirection,
            proceedTitle: proceedTitle
        }
    }

    initialValues = {
        businessName: '',
        country: '',
        state: '',
        distance: 0,
        direction: '',
        stateOptions: []
    }

    validationSchema = Yup.object().shape({
        businessName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .max(FormConst.DESTINATION_NAME_MAX_LENGTH, `Up to ${FormConst.DESTINATION_NAME_MAX_LENGTH} characters allowed`)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        country: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        state: Yup.string().test('State is required for countries that have subdivisions', FormConst.VALIDATION_ERROR_REQUIRED, val => isArrayNotEmpty(this.state.initialValues.stateOptions) ? !!val : true),
        distance: Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .min(0, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_OR_EQUAL_TO_ZERO)
            .max(FormConst.MAX_DESTINATION_DISTANCE, FormConst.VALIDATION_ERROR_DESTINATIONS_DISTANCE),
        direction: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
    })

    /**
     * Lifecycle method that runs after the component mounts.
     * Gets data from the session if state is COMPLETED, otherwise from the service, and sets initial values for the form.
     */
    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            let hotelDestinations = this.state.hotelInfoCompletedHistory.newEntity?.hotelDestinations?.hotelDestinations;
            await this.buildFormValues(hotelDestinations);
        } else {
            await DestinationsService.getHotelDestinations({ hotelCode: this.state.hotelCode })
                .then(async response => {
                    let hotelDestinations = response?.hotelDestinations;
                    await this.buildFormValues(hotelDestinations);
                }).catch(error => {
                    this.setState({ error: 'Could not retrieve destination details', isLoading: false })
                })
        }
    }

    async buildFormValues(hotelDestinations) {
        let loadingBusinesses = []
        let existingBusinesses = []
        let otherDestinationEntries = {}
        let spaEntry = {};

        const businesses = hotelDestinations.business
        otherDestinationEntries = !isObjectEmpty(hotelDestinations) ? {
                ...hotelDestinations,
                business: undefined
            }
            :
            { business: undefined }

        if(businesses) {
            businesses.forEach(business => {
                if (business.destinationType === FormConst.DESTINATION_TYPE_SPA) {
                    spaEntry = business
                } else {
                    loadingBusinesses.push(business)
                }
            });
        }

        if (loadingBusinesses) {
            existingBusinesses = loadingBusinesses && loadingBusinesses.length > 0 ? [...loadingBusinesses] : []
        }

        await CountryService.getCountries({
            hotelCode: this.state.hotelCode
        }).then(countryServiceResponse => {
            let countryOptions = countryServiceResponse.countries.map(country => {
                return {
                    label: country.name,
                    value: country.iso2Code
                }
            })

            countryOptions = sortObjectList(countryOptions, 'label')
            this.setState({
                businesses: existingBusinesses,
                otherDestinationEntries: otherDestinationEntries,
                spaEntry: spaEntry,
                isLoading: false,
                countryOptions: countryOptions
            })
        }).catch(error => {
            this.setState({
                error: 'Could not retrieve country details',
                isLoading: false,
                businesses: existingBusinesses,
                otherDestinationEntries: otherDestinationEntries,
                spaEntry: spaEntry
            })
        });
    }

    handleSubmit = (formData) => {
        let businesses = this.state.businesses.length > 0 ? [...this.state.businesses] : []
        const newEntry = {
            destinationType: FormConst.DESTINATION_TYPE_BUSINESS,
            name: formData.businessName.trim(),
            proximity: {
                distanceValue: formData.distance,
                distanceUnit: this.state.distanceUnits,
                direction: formData.direction
            },
            address: {
                state: formData.state || undefined,
                country: formData.country
            }
        }

        if (this.state.isEdit) {
            // Edit existing entry
            businesses[this.state.editIndex] = newEntry
        } else {
            businesses.push(newEntry)
        }

        let newDestinationEntries
        if (this.state.otherDestinationEntries) {
            newDestinationEntries = {
                ...this.state.otherDestinationEntries,
                business: [...businesses]
            }
        } else {
            newDestinationEntries = {
                business: [...businesses]
            }
        }

        if (this.state.spaEntry !== undefined && this.state.spaEntry.destinationType !== undefined) {
            newDestinationEntries.business.push(this.state.spaEntry)
        }

        this.props.onPut({ hotelCode: this.state.hotelCode, formData: newDestinationEntries })
        this.setState({
            pendingBusinesses: [...businesses],
            newPendingBusiness: { ...formData },
            isLoading: true,
            loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT
        })
    }

    handleReset = () => {
    }

    handleDelete = (index) => {
        this.setState({ showDeleteModal: true, deleteIndex: index })
    }

    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    discardNewFields = (formikResetForm) => {
        formikResetForm({ ...this.initialValues })
        // Scroll the table into view after discarding
        scrollToHtmlElementById('businesses-table')
        this.setState({
            initialValues: { ...this.initialValues },
            isEdit: false,
            editIndex: -1,
            showNewBusinessFields: false,
            showResetModal: false
        })
    }

    handleProceed = () => {
        // Continue to next form
        if (this.state.continueFlow) {
            // Go to the next page
            this.props.history.push({
                pathname: this.state.proceedDirection,
                state: {
                    continueFlow: this.state.continueFlow
                }
            })
        } else {
            // Go back to Destinations page
            this.props.history.push(RouteConst.ROUTE_DESTINATIONS_PAGE)
        }
    }

    onEdit = async (index) => {
        const entryToEdit = this.state.businesses[index]

        await CountryService.getCountries({
            hotelCode: this.state.hotelCode,
            queryParams: { countryCode: entryToEdit.address.country, expand: 'subdivisions' }
        }).then(async countryServiceResponse => {

            const country = countryServiceResponse.countries[0]
            const states = country.subdivisions

            const stateOptions = states.map(state => {
                return {
                    label: state.name,
                    value: state.isoCode.split('-')[1]
                }
            })
            this.setState({
                isEdit: true,
                editIndex: index,
                isLoading: false,
                initialValues: {
                    businessName: entryToEdit.name,
                    country: entryToEdit.address.country,
                    state: entryToEdit.address.state || '',
                    distance: entryToEdit.proximity.distanceValue,
                    direction: entryToEdit.proximity.direction,
                    stateOptions: stateOptions
                },
                showNewBusinessFields: true
            })
        }).catch(error => {
            this.setState({
                isLoading: false,
                showErrorModal: true,
                error: 'Could not retrieve country details'
            })
        })
    }

    onDelete = () => {
        let index = this.state.deleteIndex
        let businesses = [...this.state.businesses]
        businesses.splice(index, 1)

        let newDestinationEntries

        if (businesses.length > 0 && !isObjectEmpty(this.state.otherDestinationEntries)) {
            newDestinationEntries = {
                ...this.state.otherDestinationEntries,
                business: [...businesses]
            }
        } else if (businesses.length > 0) {
            newDestinationEntries = {
                business: [...businesses]
            }
        } else {
            newDestinationEntries = {
                ...this.state.otherDestinationEntries
            }
        }

        this.props.onPut({ hotelCode: this.state.hotelCode, formData: newDestinationEntries })

        this.setState({
            pendingBusinesses: [...businesses],
            newPendingBusiness: undefined,
            isLoading: true,
            loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT,
            showDeleteModal: false
        })
    }

    addBusiness = () => {
        const country = this.state.countryCode
        this.getStatesForCountry(country)
        this.setState({
            isEdit: false, editIndex: -1, showNewBusinessFields: true,
            initialValues: {
                ...this.state.initialValues,
                country: country,
                stateOptions: []
            }
        })
    }

    getStatesForCountry = (country, values) => {
        this.props.onGetStates({ hotelCode: this.state.hotelCode, queryParams: { countryCode: country, expand: 'subdivisions' } })
        this.setState({ isLoading: true, initialValues: { ...values, country: country, state: '', stateOptions: [] } })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription,
                    pendingBusinesses: undefined,
                    newPendingBusiness: undefined,
                    initialValues: {
                        ...this.initialValues,
                        ...this.state.newPendingBusiness
                    }
                })
            } else {

                if (this.props.httpAction === actionTypes.ASYNC_ACTIONS.GET_STATES) {
                    const country = this.props.destinationsResponse.countries[0]
                    const states = country.subdivisions

                    const stateOptions = states.map(state => {
                        return {
                            label: state.name,
                            value: state.isoCode.split('-')[1]
                        }
                    })

                    this.setState({
                        isLoading: false,
                        initialValues: {
                            ...this.state.initialValues,
                            country: country.iso2Code,
                            state: '',
                            stateOptions: sortObjectList(stateOptions, 'label')
                        }
                    })
                } else {
                    // Scroll the table into view after saving
                    scrollToHtmlElementById('businesses-table')
                    this.setState({
                        isLoading: false, businesses: this.state.pendingBusinesses,
                        initialValues: { ...this.initialValues }, showNewBusinessFields: false,
                        isEdit: false, editIndex: -1, deleteIndex: -1, showDeleteModal: false
                    })
                }
            }
        }
    }

    render() {
        let formTable = <table id='businesses-table' className='table table-striped businesses-table'>
            <thead>
                <tr>
                    <th>Business Name</th>
                    <th className='d-none d-lg-table-cell'>Country</th>
                    <th className='d-none d-lg-table-cell'>State</th>
                    <th>Edit</th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>
                {
                    isArrayNotEmpty(this.state.businesses)
                        ? this.state.businesses.map((business, index) => {
                            return <tr key={index}>
                                <td>{business.name}</td>
                                <td className='d-none d-lg-table-cell'>{business.address.country}</td>
                                <td className='d-none d-lg-table-cell'>{business.address.state}</td>
                                <td><Button role='link' name={<FaEdit />} className={this.state.showNewBusinessFields ? 'icon-link-disabled' : 'icon-link'} onClick={() => this.onEdit(index)} overridedisabledflag='true' /></td>
                                <td><Button role='link' name={<FaTrashAlt />} className={this.state.showNewBusinessFields ? 'icon-link-disabled' : 'icon-link'} onClick={() => this.handleDelete(index)} /></td>
                            </tr>
                        })
                        : <tr>
                            <td colSpan={5}>There are no entries for businesses</td>
                        </tr>
                }
            </tbody>
        </table>

        return (
            <Formik
                initialValues={this.state.initialValues}
                validationSchema={this.validationSchema}
                enableReinitialize={true}
                onSubmit={(data, { setSubmitting, resetForm }) => {
                    setSubmitting(true)
                    this.handleSubmit(data)
                    setSubmitting(false)
                    resetForm()
                }}>
                {
                    ({ values, errors, touched, dirty, isSubmitting, isValid, resetForm, handleChange }) => (
                        <Form className='businesses-form'>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                                    <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_DESTINATIONS_PAGE}>Destinations</NavLink></li>
                                    <li className="breadcrumb-item active" aria-current="page">Businesses</li>
                                </ol>
                            </nav>
                            <p className='hotel-destinations-type'>
                                Area Businesses (Universities, Hospitals, Military Installations, Corporate or Government Offices, Industrial Parks)
                            </p>
                            <p className='helper-text'>{FormConst.BUSINESSES_HELPER_TEXT}</p>

                            {formTable}

                            {
                                this.state.businesses.length < FormConst.DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MAX_COUNT
                                && <div className='new-businesses-fields-toggle'>
                                    <Button
                                        id='add-business-button'
                                        name='Add Business'
                                        disabled={this.state.showNewBusinessFields}
                                        onClick={this.addBusiness} />
                                </div>
                            }

                            {/* Show new business fields only when add button is clicked */}
                            {
                                this.state.showNewBusinessFields
                                && <div id='new-business-collapse-fields'>
                                    <div className='new-business-form-fields'>
                                        <TextInput name='businessName' type='text' label='Business Name' isrequired='true' />
                                        <SelectInput
                                            name='country'
                                            type='text'
                                            label='Country'
                                            onInput={(e) => this.getStatesForCountry(e.target.value, values)}
                                            options={this.state.countryOptions}
                                            isrequired='true' />
                                        {
                                            isArrayNotEmpty(values.stateOptions)
                                            && <SelectInput
                                                name='state'
                                                type='text'
                                                label='State'
                                                isrequired={FormConst.VALUE_TRUE_STRING}
                                                options={values.stateOptions} />
                                        }
                                        <TextInput
                                            name='distance'
                                            type='number'
                                            label='Distance'
                                            suffix={this.state.distanceUnits}
                                            min={0}
                                            max={FormConst.MAX_DESTINATION_DISTANCE}
                                            step='0.5'
                                            isrequired='true' />
                                        <SelectInput
                                            name='direction'
                                            label='Direction'
                                            options={FormConst.DIRECTION_OPTIONS}
                                            isrequired='true' />
                                    </div>
                                    <Row>
                                        <Col xs={3} sm={2} lg={1}><Button role='link' type="submit" name={FormConst.SAVE_LINK_TEXT} className="new-business-action-button" formNoValidate /></Col>
                                        <Col xs={4} sm={2} lg={1}><Button role='link' name={FormConst.DISCARD_LINK_TEXT} className="new-business-action-button" onClick={() => {
                                            if (dirty) {
                                                this.handleClearForm()
                                            } else {
                                                this.discardNewFields(resetForm)
                                            }
                                        }
                                        }
                                            overridedisabledflag='true' /></Col>
                                    </Row>
                                </div>
                            }

                            {
                                this.state.showNewBusinessFields
                                && <p className='error text-center'>Please save or discard your changes to proceed</p>
                            }

                            <FormFooter
                                form={{
                                    previous: { title: 'Attractions', route: RouteConst.ROUTE_ATTRACTIONS_PAGE },
                                    next: { title: this.state.proceedTitle, route: this.state.proceedDirection }
                                }}
                                submitName={this.state.continueFlow ? 'Proceed to ' + this.state.proceedTitle : 'Go back to Destinations'}
                                onSubmit={this.handleProceed}
                                submitDisabled={this.state.showNewBusinessFields}
                                noReset />
                            <FormModal
                                id='businesses-page-save-modal'
                                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                hotelInfo={this.state.hotelInfo}
                                body={<h5>{this.state.loadingMessage}</h5>}
                                show={this.state.isLoading}
                                isLoadingIndicator />
                            <FormModal
                                id='businesses-page-discard-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_DISCARD_ACTION_TITLE}
                                body={<h5>{FormConst.MODAL_DISCARD_ACTION_TEXT}</h5>}
                                proceed={() => {
                                    this.discardNewFields(resetForm)
                                }}
                                cancel={() => { this.setState({ showResetModal: false }) }}
                                show={this.state.showResetModal} />
                            <FormModal
                                id='businesses-page-delete-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={'Delete Business'}
                                body={<h5>{FormConst.MODAL_DELETE_ACTION_TEXT}</h5>}
                                proceed={this.onDelete}
                                cancel={() => { this.setState({ showDeleteModal: false }) }}
                                show={this.state.showDeleteModal} />
                            <FormModal
                                id='businesses-page-error-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                body={<h5>{this.state.errorMessage}</h5>}
                                isError
                                cancel={() => { this.setState({ showErrorModal: false }) }}
                                show={this.state.showErrorModal} />
                        </Form>
                    )
                }
            </Formik>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        destinationsResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count,
        httpAction: state.reducer.httpAction
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data)),
        onGetStates: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.GET_STATES, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(Businesses, SideNavEntryMapping.HOTEL_DESTINATIONS))